import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../modules/auth'
import axios from 'axios'

export default function NewGameDashboard() {
    const { currentUser } = useAuth()
    const navigate = useNavigate()

    // User Information
    const displayName = currentUser?.fullname || [currentUser?.first_name, currentUser?.last_name].filter(Boolean).join(' ') || 'Lalit pant'
    const email = currentUser?.email || 'lalit@gmail.com'
    const userCode = currentUser?.user_code || 'USR2024001'
    const mobile = currentUser?.phone || '8968534405'
    const company = currentUser?.company_name || 'XXXXXXX'
    const initials = displayName?.split(' ').map(w => w[0]).join('').substring(0, 2).toUpperCase()

    // Games State
    const [games, setGames] = useState([])
    const [loading, setLoading] = useState(true)

    // Fetch games data
    useEffect(() => {
        const fetchGames = async () => {
            try {
                // TODO: Replace with actual API endpoint
                const response = await axios.get('/api/games')
                setGames(response.data || [])
            } catch (error) {
                console.error('Error fetching games:', error)
                // Set dummy data for development
                setGames([
                    {
                        id: 1,
                        name: ' SPIN & WIN',
                        icon: '🎲',
                        tags: ['#mohali', '#mohali'],
                        status: 'live',
                        campaigns: 2,
                        sponsor: 'Gillette'
                    },
                    {
                        id: 2,
                        name: ' Jeet ka Jackpot',
                        icon: '⚔️',
                        tags: ['#partygames', '#action-adventure'],
                        status: 'live',
                        campaigns: 1,
                        sponsor: 'Gillette'
                    },
                    {
                        id: 3,
                        name: 'Jeet ka Jackpot',
                        icon: '🎰',
                        tags: ['#partygames', '#multiplayer'],
                        status: 'archive',
                        campaigns: 2,
                        sponsor: 'Gillette'
                    },
                    {
                        id: 4,
                        name: 'Jeet ka Jackpot',
                        icon: '🍬',
                        tags: ['#puzzle', '#casual'],
                        status: 'live',
                        campaigns: 3,
                        sponsor: 'Gillette'
                    },
                    {
                        id: 5,
                        name: 'Jeet ka Jackpot',
                        icon: '🏃',
                        tags: ['#action', '#adventure'],
                        status: 'live',
                        campaigns: 1,
                        sponsor: 'Gillette'
                    }
                ])
            } finally {
                setLoading(false)
            }
        }

        fetchGames()
    }, [])

    return (
        <div className='min-vh-100' style={{ background: '#f5f7fa' }}>
            <div className='container py-4 py-md-5 px-3 px-md-4' style={{ maxWidth: '900px' }}>

                {/* User Profile Card */}
                <div className='card border-0 shadow-sm rounded-4 mb-4 overflow-hidden'>
                    <div
                        className='p-4 p-md-5'
                        style={{
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            position: 'relative'
                        }}
                    >
                        {/* Profile Section */}
                        <div className='d-flex flex-column flex-md-row align-items-center align-items-md-start gap-3 mb-4'>
                            {/* Avatar */}
                            <div className='position-relative'>
                                <div
                                    className='rounded-circle d-flex align-items-center justify-content-center shadow-lg position-relative'
                                    style={{
                                        width: '80px',
                                        height: '80px',
                                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                        border: '4px solid rgba(255, 255, 255, 0.3)'
                                    }}
                                >
                                    <span className='fs-2 fw-bold text-white'>{initials}</span>
                                </div>
                                {/* Active Status Badge */}
                                <div
                                    className='position-absolute'
                                    style={{
                                        bottom: '0',
                                        right: '0',
                                        width: '24px',
                                        height: '24px',
                                        background: '#10b981',
                                        border: '3px solid white',
                                        borderRadius: '50%'
                                    }}
                                />
                            </div>

                            {/* User Info */}
                            <div className='flex-grow-1 text-center text-md-start'>
                                <h2 className='mb-2 fw-bold text-white' style={{ fontSize: '28px' }}>
                                    {displayName}
                                </h2>
                                <div className='d-flex align-items-center justify-content-center justify-content-md-start gap-2 mb-3'>
                                    <i className='bi bi-envelope-fill text-white opacity-75'></i>
                                    <span className='text-white opacity-90' style={{ fontSize: '14px' }}>
                                        {email}
                                    </span>
                                </div>
                            </div>
                        </div>

                        {/* Info Cards */}
                        <div className='row g-3'>
                            {/* Company */}
                            <div className='col-12 col-md-4'>
                                <div
                                    className='rounded-3 p-3 h-100'
                                    style={{ background: 'rgba(255, 255, 255, 0.15)', backdropFilter: 'blur(10px)' }}
                                >
                                    <div className='d-flex align-items-center gap-3'>
                                        <div
                                            className='rounded-2 d-flex align-items-center justify-content-center'
                                            style={{
                                                width: '40px',
                                                height: '40px',
                                                background: 'rgba(255, 255, 255, 0.2)'
                                            }}
                                        >
                                            <i className='bi bi-building text-white fs-5'></i>
                                        </div>
                                        <div>
                                            <div className='text-white opacity-75 mb-1' style={{ fontSize: '12px' }}>
                                                Company
                                            </div>
                                            <div className='text-white fw-semibold' style={{ fontSize: '14px' }}>
                                                {company}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* User Code */}
                            <div className='col-12 col-md-4'>
                                <div
                                    className='rounded-3 p-3 h-100'
                                    style={{ background: 'rgba(255, 255, 255, 0.15)', backdropFilter: 'blur(10px)' }}
                                >
                                    <div className='d-flex align-items-center gap-3'>
                                        <div
                                            className='rounded-2 d-flex align-items-center justify-content-center'
                                            style={{
                                                width: '40px',
                                                height: '40px',
                                                background: 'rgba(255, 255, 255, 0.2)'
                                            }}
                                        >
                                            <i className='bi bi-hash text-white fs-5'></i>
                                        </div>
                                        <div>
                                            <div className='text-white opacity-75 mb-1' style={{ fontSize: '12px' }}>
                                                User Code
                                            </div>
                                            <div className='text-white fw-semibold' style={{ fontSize: '14px' }}>
                                                {userCode}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Mobile */}
                            <div className='col-12 col-md-4'>
                                <div
                                    className='rounded-3 p-3 h-100'
                                    style={{ background: 'rgba(255, 255, 255, 0.15)', backdropFilter: 'blur(10px)' }}
                                >
                                    <div className='d-flex align-items-center gap-3'>
                                        <div
                                            className='rounded-2 d-flex align-items-center justify-content-center'
                                            style={{
                                                width: '40px',
                                                height: '40px',
                                                background: 'rgba(255, 255, 255, 0.2)'
                                            }}
                                        >
                                            <i className='bi bi-phone text-white fs-5'></i>
                                        </div>
                                        <div>
                                            <div className='text-white opacity-75 mb-1' style={{ fontSize: '12px' }}>
                                                Mobile
                                            </div>
                                            <div className='text-white fw-semibold' style={{ fontSize: '14px' }}>
                                                {mobile}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Games Section */}
                <div>
                    <h3 className='mb-4 fw-bold' style={{ fontSize: '24px', color: '#1e293b' }}>
                        Games <span style={{ color: '#667eea' }}>({games.length})</span>
                    </h3>
                    <div className='mb-5'>
                        <div style={{ fontSize: '14px', }}>
                            Games associated with this user will appear here.
                        </div>
                    </div>


                    {/* Loading State */}
                    {loading && (
                        <div className='text-center py-5'>
                            <div className='spinner-border text-primary' role='status'>
                                <span className='visually-hidden'>Loading...</span>
                            </div>
                        </div>
                    )}

                    {/* Games List */}
                    {!loading && (
                        <div className='d-flex flex-column gap-3'>
                            {games.map((game) => (
                                <div
                                    key={game.id}
                                    className='card border-0 shadow-sm rounded-4 p-3 position-relative overflow-hidden'
                                    style={{
                                        transition: 'all 0.3s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-2px)'
                                        e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.12)'
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)'
                                        e.currentTarget.style.boxShadow = ''
                                    }}
                                >
                                    <div className='d-flex align-items-center gap-3'>
                                        {/* Game Icon */}
                                        <div
                                            className='rounded-3 d-flex align-items-center justify-content-center flex-shrink-0 shadow-sm'
                                            style={{
                                                width: '64px',
                                                height: '64px',
                                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                                fontSize: '32px'
                                            }}
                                        >
                                            {game.icon}
                                        </div>

                                        {/* Game Info */}
                                        <div className='flex-grow-1 min-w-0'>
                                            <div className='d-flex align-items-start justify-content-between gap-2 mb-2'>
                                                <h4 className='mb-0 fw-bold' style={{ fontSize: '18px', color: '#1e293b' }}>
                                                    {game.name}
                                                </h4>

                                                {/* Status Badge */}
                                                {/* <span
                                                    className='badge rounded-pill px-2 px-md-3 py-1 py-md-2 text-uppercase fw-semibold flex-shrink-0'
                                                    style={{
                                                        fontSize: '10px',
                                                        letterSpacing: '0.5px',
                                                        background: game.status === 'live' ? '#10b981' : '#f59e0b',
                                                        color: 'white'
                                                    }}
                                                >
                                                    {game.status}
                                                </span> */}
                                            </div>

                                            {/* Tags */}
                                            {/* <div className='d-flex flex-wrap gap-2 mb-2'>
                                                {game.tags.map((tag, index) => (
                                                    <span
                                                        key={index}
                                                        className='badge rounded-pill px-2 py-1'
                                                        style={{
                                                            fontSize: '11px',
                                                            background: '#ede9fe',
                                                            color: '#7c3aed',
                                                            fontWeight: '500'
                                                        }}
                                                    >
                                                        {tag}
                                                    </span>
                                                ))}
                                            </div> */}

                                            {/* Campaign & Sponsor Info */}
                                            <div className='d-flex flex-wrap align-items-center gap-2 gap-md-3'>
                                                <div className='d-flex align-items-center gap-2'>
                                                    <i className='bi bi-people-fill' style={{ color: '#667eea', fontSize: '14px' }}></i>
                                                    <span style={{ fontSize: '13px', color: '#64748b' }}>
                                                        <span className='fw-semibold' style={{ color: '#1e293b' }}>
                                                            {game.campaigns}
                                                        </span>{' '}
                                                        {game.campaigns === 1 ? 'Campaign' : 'Campaigns'}
                                                    </span>
                                                </div>

                                                <div className='d-flex align-items-center gap-2'>
                                                    <i className='bi bi-star-fill' style={{ color: '#667eea', fontSize: '14px' }}></i>
                                                    <span style={{ fontSize: '13px', color: '#64748b' }}>
                                                        {game.sponsor}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Play Button */}
                                        <div className='flex-shrink-0'>
                                            <button
                                                className='btn btn-primary rounded-3 d-flex align-items-center justify-content-center gap-2 px-3 py-2'
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    navigate(`/admin/games/${game.id}`)
                                                }}
                                                style={{
                                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                                    border: 'none',
                                                    fontWeight: '600',
                                                    fontSize: '14px',
                                                    minWidth: '80px'
                                                }}
                                            >
                                                <i className='bi bi-play-fill' style={{ fontSize: '16px' }}></i>
                                                <span className='d-none d-sm-inline'>Play</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    {/* Empty State */}
                    {!loading && games.length === 0 && (
                        <div className='text-center py-5'>
                            <div className='mb-3' style={{ fontSize: '48px' }}>🎮</div>
                            <p className='text-muted mb-0'>No games available</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

